import { cn } from "@/lib/cn";
import { Skeleton } from "../Skeleton";
import { RegionCargando } from "./RegionCargando";

export interface ListaControlesSkeletonProps {
  filas?: number;
  /**
   * "switch": texto (2 líneas) + interruptor a la derecha (preferencias, módulos) ·
   * "checkbox": casilla + texto (permisos, organizaciones).
   */
  control?: "switch" | "checkbox";
  /** Filas divididas dentro de un borde (`divide-y`), como las listas de preferencias. */
  conBorde?: boolean;
  /** Segunda línea de descripción bajo el texto. */
  conDescripcion?: boolean;
  className?: string;
  /** false cuando ya lo anuncia un contenedor padre. */
  anunciar?: boolean;
  etiqueta?: string;
}

/** Lista de opciones con switch o checkbox en carga (mismas medidas que `Switch`/`Checkbox`). */
export function ListaControlesSkeleton({
  filas = 5,
  control = "switch",
  conBorde = false,
  conDescripcion = control === "switch",
  className,
  anunciar = true,
  etiqueta,
}: ListaControlesSkeletonProps) {
  const clases = cn(
    "flex flex-col",
    conBorde ? "divide-y divide-border rounded-md border border-border" : control === "checkbox" ? "gap-2.5" : "gap-1",
    className,
  );
  const contenido = Array.from({ length: filas }, (_, i) => {
    const texto = (
      <div className="flex min-w-0 flex-1 flex-col gap-1.5">
        <Skeleton height={12} width={i % 3 === 0 ? "55%" : i % 3 === 1 ? "40%" : "48%"} />
        {conDescripcion && <Skeleton height={10} width={i % 2 === 0 ? "75%" : "62%"} />}
      </div>
    );
    return control === "switch" ? (
      <div key={i} className={cn("flex items-center justify-between gap-3", conBorde ? "px-3 py-2" : "py-1.5")} aria-hidden="true">
        {texto}
        <Skeleton height={20} width={36} className="shrink-0 rounded-full" />
      </div>
    ) : (
      <div key={i} className={cn("flex items-center gap-2.5", conBorde && "px-3 py-2")} aria-hidden="true">
        <Skeleton height={16} width={16} className="shrink-0 rounded-sm" />
        {texto}
      </div>
    );
  });
  return anunciar ? (
    <RegionCargando etiqueta={etiqueta} className={clases}>
      {contenido}
    </RegionCargando>
  ) : (
    <div className={clases}>{contenido}</div>
  );
}
